module.exports = __webpack_public_path__ + "img/Envelope.6429a9f8.svg";